import graphql from "babel-plugin-relay/macro";
import { readInlineData } from "react-relay";

import { packageMissingPaymentMethod_memberPackage$key } from "./__generated__/packageMissingPaymentMethod_memberPackage.graphql";

export const packageMissingPaymentMethod = (
  memberPackageRef?: packageMissingPaymentMethod_memberPackage$key | null
) => {
  const memberPackage = readInlineData(
    packageMissingPaymentMethodFragmentString,
    memberPackageRef
  );

  return (
    memberPackage?.package?.billingType === "SUBSCRIPTION" &&
    !memberPackage?.squareCard
  );
};

const packageMissingPaymentMethodFragmentString = graphql`
  fragment packageMissingPaymentMethod_memberPackage on MemberPackage @inline {
    squareCard {
      id
    }
    package {
      billingType
    }
  }
`;
